import classNames from "classnames";
import { FC } from "react";

import Modal from "components/Modal";

import ModalRemoveGatewayContent from "./Content";

import styles from "./styles.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  id?: number;
  name?: string;
  callbackKey?: string;
};

const WidgetModalRemoveGateway: FC<PropTypes> = ({ isVisible, className, id, name, callbackKey }) => {
  return (
    <Modal
      title="Delete gateway"
      isClose
      isCloseBg
      isVisible={isVisible}
      className={classNames(styles.modal, className)}
    >
      <ModalRemoveGatewayContent id={id} name={name} callbackKey={callbackKey} />
    </Modal>
  );
};

export default WidgetModalRemoveGateway;
